import React from 'react';
import './index.css';
import ourpromiseimg1 from '../../../assets/images/OurPromise01.PNG';
import ourpromiseimg2 from '../../../assets/images/OurPromise02.PNG';
import ourpromiseimg3 from '../../../assets/images/OurPromise03.PNG';

const OurPromise = () => {
  return (
    <div className="our-promise-container">
      <h1>Our Promise</h1>
      <div className="promise-cards">
        <div className="promise-card">
          <div className="icon-container">
            <img src={ourpromiseimg1} alt="icon" />
          </div>
          <h4>Quality Commitment</h4>
          <p>Crafted with care, every meal meets our highest standards of freshness, flavour, and food safety.</p>
        </div>
        <div className="promise-card">
          <div className="icon-container">
            <img src={ourpromiseimg2} alt="icon" />
          </div>
          <h4>Consistent Service</h4>
          <p>Connected to understand your preferences — delivering them with excellence to make every pack truly delicious.</p>
        </div>
        <div className="promise-card">
          <div className="icon-container">
            <img src={ourpromiseimg3} alt="icon" />
          </div>
          <h4>Community Focus</h4>
          <p>Nourishing communities through local sourcing, jobs, and hospitality — eagerly incorporating your suggestions every step of the way.</p>
        </div>
      </div>
    </div>
  );
};

export default OurPromise;